import { UseCase } from "./interfaces";

export const useCases: UseCase[] = [
	{
		name: "Best Practices",
		value: 1,
		helpingText: "What are the current best practices in the industry?",
		route: "/chat/bestPractices",
		sprite: (
			<svg
				width="36"
				height="36"
				viewBox="0 0 36 36"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M25.6201 18.8086C26.9561 18.9492 27.4483 20.5664 26.5342 21.5508L21.1904 26.7539L22.4561 34.1367C22.5264 34.5586 22.3858 35.0508 22.0342 35.4023C21.7529 35.7539 21.3311 35.9648 20.8389 35.9648C20.5576 35.9648 20.3467 35.8945 20.0654 35.8242L13.5264 32.3086L6.91701 35.8242C6.63576 35.9648 6.42482 35.9648 6.14357 35.9648C5.65138 35.9648 5.22951 35.7539 4.94826 35.4023C4.66701 35.0508 4.52638 34.5586 4.59669 34.1367L5.79201 26.7539L0.518568 21.5508C-0.465807 20.6367 0.0263809 18.9492 1.36232 18.8086L8.74513 17.6836L12.0498 11.0039C12.3311 10.4414 12.8936 10.0898 13.4561 10.0898C14.0889 10.0898 14.6514 10.4414 14.9326 11.0039L18.2373 17.6836L25.6201 18.8086ZM18.7295 25.9805L24.0029 20.8477L16.7608 19.793L13.5264 13.1836L10.2217 19.793L2.97951 20.8477L8.18263 25.9805L6.98732 33.2227L13.4561 29.7773L19.9951 33.2227L18.7295 25.9805ZM16.9014 6.71484C16.5498 6.71484 16.2686 6.64453 16.0576 6.43359C15.6358 6.01172 15.6358 5.23828 16.0576 4.81641L20.5576 0.316406C20.9795 -0.105469 21.7529 -0.105469 22.1748 0.316406C22.5967 0.738281 22.5967 1.51172 22.1748 1.93359L17.6748 6.43359C17.4639 6.64453 17.1826 6.71484 16.9014 6.71484ZM22.8076 13.1836C22.3858 12.7617 22.3858 11.9883 22.8076 11.5664L34.0576 0.316406C34.4795 -0.105469 35.2529 -0.105469 35.6748 0.316406C36.0967 0.738281 36.0967 1.51172 35.6748 1.93359L24.4248 13.1836C24.2139 13.3945 23.9326 13.4648 23.6514 13.4648C23.2998 13.4648 23.0186 13.3945 22.8076 13.1836ZM34.0576 13.8164C34.4795 13.3945 35.2529 13.3945 35.6748 13.8164C36.0967 14.2383 36.0967 15.0117 35.6748 15.4336L31.1748 19.9336C30.9639 20.1445 30.6826 20.2148 30.4014 20.2148C30.0498 20.2148 29.7686 20.1445 29.5576 19.9336C29.1358 19.5117 29.1358 18.7383 29.5576 18.3164L34.0576 13.8164Z"
					fill="#1D387D"
				/>
			</svg>
		),
	},
	{
		name: "Vendor Selection",
		value: 3,
		helpingText: "Which vendors should you partner with?",
		route: "/chat/vendorSelection",
		sprite: (
			<svg
				width="45"
				height="36"
				viewBox="0 0 45 36"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M22.4297 22.5C18.4219 22.5 15.1172 19.2656 15.1875 15.1875C15.1875 11.1797 18.4219 7.875 22.4297 7.875C26.4375 7.875 29.7422 11.1797 29.7422 15.1875C29.7422 19.2656 26.5078 22.5 22.4297 22.5ZM22.4297 10.125C19.6875 10.125 17.3672 12.4453 17.3672 15.1875C17.3672 18 19.6875 20.25 22.4297 20.25C25.2422 20.25 27.4922 18 27.4922 15.1875C27.4922 12.4453 25.2422 10.125 22.4297 10.125ZM25.9453 24.75C31.5 24.75 36 28.9688 36 34.1719C36 35.2266 35.0859 36 33.9609 36H10.9688C9.84375 36 9 35.2266 9 34.1719C9 28.9688 13.4297 24.75 18.9844 24.75H25.9453ZM11.25 33.75H33.6797C33.4688 30.0234 30.0938 27 25.9453 27H18.9141C14.8359 27 11.4609 30.0234 11.25 33.75ZM36 11.25C32.8359 11.25 30.375 8.78906 30.375 5.625C30.375 2.53125 32.8359 0 36 0C39.0938 0 41.625 2.53125 41.625 5.625C41.625 8.78906 39.0938 11.25 36 11.25ZM36 2.25C34.1016 2.25 32.625 3.79688 32.625 5.625C32.625 7.52344 34.1016 9 36 9C37.8281 9 39.375 7.52344 39.375 5.625C39.375 3.79688 37.8281 2.25 36 2.25ZM9 11.25C5.83594 11.25 3.375 8.78906 3.375 5.625C3.375 2.53125 5.83594 0 9 0C12.0938 0 14.625 2.53125 14.625 5.625C14.625 8.78906 12.0938 11.25 9 11.25ZM9 2.25C7.10156 2.25 5.625 3.79688 5.625 5.625C5.625 7.52344 7.10156 9 9 9C10.8281 9 12.375 7.52344 12.375 5.625C12.375 3.79688 10.8281 2.25 9 2.25ZM39.4453 13.5C42.4688 13.5 45 16.1719 45 19.3359V20.25C45 20.8828 44.4375 21.375 43.875 21.375C43.2422 21.375 42.75 20.8828 42.75 20.25V19.3359C42.75 17.3672 41.2031 15.75 39.4453 15.75H34.875C34.3828 15.75 33.9609 15.8906 33.5391 16.1016C32.9766 16.3828 32.2734 16.1016 31.9922 15.5391C31.7812 14.9766 31.9922 14.3438 32.5547 14.0625C33.2578 13.7109 34.0312 13.5 34.875 13.5H39.4453ZM11.3906 16.1016C10.9688 15.8906 10.5469 15.75 10.125 15.75H5.48438C3.72656 15.75 2.25 17.3672 2.25 19.3359V20.25C2.25 20.8828 1.6875 21.375 1.125 21.375C0.492188 21.375 0 20.8828 0 20.25V19.3359C0 16.1719 2.46094 13.5 5.48438 13.5H10.125C10.8984 13.5 11.6719 13.7109 12.375 14.0625C12.9375 14.3438 13.1484 14.9766 12.9375 15.5391C12.6562 16.1016 11.9531 16.3828 11.3906 16.1016Z"
					fill="#1D387D"
				/>
			</svg>
		),
	},
	{
		name: "Governance and Management Oversight",
		value: 7,
		helpingText: "Board relevant topics",
		route: "/chat/governanceandmanagement",
		sprite: (
			<svg
				width="28"
				height="36"
				viewBox="0 0 28 36"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M20.301 25.2422C19.3167 25.8047 17.8401 25.2422 16.7151 25.5234C15.6604 25.8047 14.676 27 13.551 27C12.3557 27 11.3714 25.8047 10.3167 25.5234C9.19167 25.2422 7.71511 25.8047 6.73073 25.2422C5.74636 24.6797 5.53542 23.1328 4.76198 22.2891C3.91823 21.5156 2.37136 21.2344 1.80886 20.3203C1.24636 19.3359 1.80886 17.8594 1.52761 16.7344C1.24636 15.6797 0.0510443 14.6953 0.0510443 13.5C0.0510443 12.375 1.24636 11.3906 1.52761 10.3359C1.80886 9.21094 1.24636 7.73438 1.80886 6.75C2.37136 5.76562 3.91823 5.55469 4.76198 4.78125C5.53542 3.9375 5.81667 2.39062 6.73073 1.82812C7.71511 1.26562 9.19167 1.82812 10.3167 1.54688C11.3714 1.26562 12.3557 0 13.551 0C14.676 0 15.6604 1.26562 16.6448 1.54688C17.7698 1.82812 19.2464 1.26562 20.2307 1.82812C21.2151 2.39062 21.426 3.9375 22.2698 4.78125C23.0432 5.55469 24.5901 5.76562 25.1526 6.75C25.7151 7.73438 25.1526 9.21094 25.4339 10.3359C25.7151 11.3906 26.9807 12.375 26.9807 13.5C26.9807 14.6953 25.7854 15.6797 25.5042 16.7344C25.2229 17.8594 25.7854 19.3359 25.2229 20.3203C24.6604 21.3047 23.1135 21.5156 22.2698 22.2891C21.4964 23.1328 21.2151 24.6797 20.301 25.2422ZM13.4807 24.75C14.1135 24.4688 14.9573 23.6953 16.1526 23.3438C17.3479 23.0625 18.4729 23.2734 19.1057 23.2734C19.4573 22.7109 19.8792 21.5859 20.7229 20.7422C21.5667 19.8984 22.6917 19.4766 23.2542 19.125C23.2542 18.4219 23.0432 17.2969 23.3245 16.1719C23.676 14.9766 24.4495 14.1328 24.7307 13.5703C24.4495 12.9375 23.676 12.0938 23.3245 10.8984C23.0432 9.70312 23.2542 8.57812 23.2542 7.94531C22.6917 7.59375 21.5667 7.17188 20.7229 6.32812C19.8792 5.48438 19.4573 4.35938 19.1057 3.79688C18.4729 3.79688 17.3479 4.00781 16.1526 3.72656C14.9573 3.375 14.1135 2.60156 13.4807 2.32031C12.9182 2.60156 12.0745 3.375 10.8792 3.72656C9.68386 4.00781 8.55886 3.79688 7.92604 3.79688C7.57448 4.35938 7.15261 5.48438 6.30886 6.32812C5.46511 7.17188 4.34011 7.59375 3.77761 7.94531C3.77761 8.57812 3.98854 9.70312 3.70729 10.8984C3.35573 12.0938 2.58229 12.9375 2.30104 13.5703C2.58229 14.1328 3.35573 14.9766 3.70729 16.1719C3.98854 17.3672 3.77761 18.4922 3.77761 19.125C4.26979 19.4766 5.39479 19.8984 6.23854 20.7422C7.08229 21.5859 7.50417 22.7109 7.85573 23.2031C8.48854 23.2734 9.61354 23.0625 10.8089 23.3438C12.0042 23.6953 12.9182 24.4688 13.4807 24.75ZM19.6682 13.5C19.6682 16.9453 16.7854 19.6875 13.4807 19.6875C10.1057 19.6875 7.36354 16.9453 7.36354 13.5C7.36354 10.125 10.176 7.3125 13.551 7.3125C16.8557 7.3125 19.6682 10.125 19.6682 13.5ZM13.551 17.4375C15.6604 17.4375 17.4182 15.6797 17.4182 13.5C17.4182 11.3906 15.5901 9.5625 13.4807 9.5625C11.3714 9.5625 9.61354 11.3906 9.61354 13.5C9.61354 15.6797 11.3714 17.4375 13.551 17.4375ZM25.1526 26.0859L26.8401 30.375C27.1917 31.1484 27.051 32.1328 26.4885 32.7656C25.926 33.4688 25.012 33.75 24.1682 33.6094L22.6214 33.2578L21.9182 34.7344C21.4964 35.5078 20.7229 36 19.8089 36C18.7542 36 17.9807 35.4375 17.6292 34.5234L15.8714 30.2344C15.5901 29.6719 15.8714 29.0391 16.4339 28.7578C17.0667 28.5469 17.6995 28.8281 17.9104 29.3906L19.6682 33.6797L21.426 30.7266L24.7307 31.2188L23.0432 26.8594C22.8323 26.2969 23.1135 25.6641 23.676 25.4531C24.2385 25.1719 24.9417 25.4531 25.1526 26.0859ZM10.5979 28.7578C11.1604 29.0391 11.4417 29.6719 11.1604 30.2344L9.40261 34.5234C9.05104 35.4375 8.27761 36 7.29323 36C6.30886 36 5.53542 35.5078 5.11354 34.7344L4.41042 33.2578L2.86354 33.6094C2.01979 33.75 1.10573 33.4688 0.543232 32.7656C-0.0192682 32.1328 -0.159893 31.1484 0.191669 30.375L1.87917 26.0859C2.09011 25.4531 2.79323 25.1719 3.35573 25.4531C3.91823 25.6641 4.19948 26.2969 3.98854 26.8594L2.30104 31.2188L5.60573 30.7266L7.36354 33.6797L9.12136 29.3906C9.33229 28.8281 9.96511 28.5469 10.5979 28.7578Z"
					fill="#1D387D"
				/>
			</svg>
		),
	},
	{
		name: "IS Framework and Maturity Assessment",
		value: 2,
		helpingText: "IS Framework and Maturity Assessment",
		route: "/maturityAssessment",
		sprite: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="28"
				height="36"
				fill="#205493"
				className="bi bi-clipboard2-data"
				viewBox="0 0 16 16"
			>
				<path d="M9.5 0a.5.5 0 0 1 .5.5.5.5 0 0 0 .5.5.5.5 0 0 1 .5.5V2a.5.5 0 0 1-.5.5h-5A.5.5 0 0 1 5 2v-.5a.5.5 0 0 1 .5-.5.5.5 0 0 0 .5-.5.5.5 0 0 1 .5-.5z" />
				<path d="M3 2.5a.5.5 0 0 1 .5-.5H4a.5.5 0 0 0 0-1h-.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1H12a.5.5 0 0 0 0 1h.5a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5z" />
				<path d="M10 7a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0zm-6 4a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0zm4-3a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1" />
			</svg>
		),
	},
];

export const adminReporting = [
	{
		name: "Add New User",
		value: 0,
		helpingText: "Create New User Accounts",
		route: "/registerUsers",
		sprite: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="33"
				height="40"
				fill="#205493"
				className="bi bi-person-add"
				viewBox="0 0 16 16"
			>
				<path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0m-2-6a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
				<path d="M8.256 14a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z" />
			</svg>
		),
	},
	{
		name: "Manage Users",
		value: 1,
		helpingText: "View and manage existing user accounts",
		route: "/adminFeatures/management/users",
		sprite: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="33"
				height="40"
				fill="#205493"
				className="bi bi-person-gear"
				viewBox="0 0 16 16"
			>
				<path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m.256 7a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1zm3.63-4.54c.18-.613 1.048-.613 1.229 0l.043.148a.64.64 0 0 0 .921.382l.136-.074c.561-.306 1.175.308.87.869l-.075.136a.64.64 0 0 0 .382.92l.149.045c.612.18.612 1.048 0 1.229l-.15.043a.64.64 0 0 0-.38.921l.074.136c.305.561-.309 1.175-.87.87l-.136-.075a.64.64 0 0 0-.92.382l-.045.149c-.18.612-1.048.612-1.229 0l-.043-.15a.64.64 0 0 0-.921-.38l-.136.074c-.561.305-1.175-.309-.87-.87l.075-.136a.64.64 0 0 0-.382-.92l-.148-.045c-.613-.18-.613-1.048 0-1.229l.148-.043a.64.64 0 0 0 .382-.921l-.074-.136c-.306-.561.308-1.175.869-.87l.136.075a.64.64 0 0 0 .92-.382zM14 12.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0" />
			</svg>
		),
	},
	{
		name: "Check Activity Logs",
		value: 2,
		helpingText: "Users' Chat and login activity",
		route: "/adminFeatures/reporting/users",
		sprite: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="33"
				height="40"
				fill="#205493"
				className="bi bi-activity"
				viewBox="0 0 16 16"
			>
				<path
					fill-rule="evenodd"
					d="M6 2a.5.5 0 0 1 .47.33L10 12.036l1.53-4.208A.5.5 0 0 1 12 7.5h3.5a.5.5 0 0 1 0 1h-3.15l-1.88 5.17a.5.5 0 0 1-.94 0L6 3.964 4.47 8.171A.5.5 0 0 1 4 8.5H.5a.5.5 0 0 1 0-1h3.15l1.88-5.17A.5.5 0 0 1 6 2"
				/>
			</svg>
		),
	},
	{
		name: "Upload Data",
		value: 3,
		helpingText: "Upload data from external sources",
		route: "/uploadFiles",
		sprite: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="28"
				height="40"
				fill="#205493"
				className="bi bi-file-earmark-arrow-up"
				viewBox="0 0 16 16"
			>
				<path d="M8.5 11.5a.5.5 0 0 1-1 0V7.707L6.354 8.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 7.707z" />
				<path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
			</svg>
		),
	},
	{
		name: "Ingest Data",
		value: 4,
		helpingText: "Ingest data from external sources",
		route: "/ingest",
		sprite: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="28"
				height="40"
				fill="#205493"
				className="bi bi-robot"
				viewBox="0 0 16 16"
			>
				<path d="M6 12.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M3 8.062C3 6.76 4.235 5.765 5.53 5.886a26.6 26.6 0 0 0 4.94 0C11.765 5.765 13 6.76 13 8.062v1.157a.93.93 0 0 1-.765.935c-.845.147-2.34.346-4.235.346s-3.39-.2-4.235-.346A.93.93 0 0 1 3 9.219zm4.542-.827a.25.25 0 0 0-.217.068l-.92.9a25 25 0 0 1-1.871-.183.25.25 0 0 0-.068.495c.55.076 1.232.149 2.02.193a.25.25 0 0 0 .189-.071l.754-.736.847 1.71a.25.25 0 0 0 .404.062l.932-.97a25 25 0 0 0 1.922-.188.25.25 0 0 0-.068-.495c-.538.074-1.207.145-1.98.189a.25.25 0 0 0-.166.076l-.754.785-.842-1.7a.25.25 0 0 0-.182-.135" />
				<path d="M8.5 1.866a1 1 0 1 0-1 0V3h-2A4.5 4.5 0 0 0 1 7.5V8a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1v1a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1v-.5A4.5 4.5 0 0 0 10.5 3h-2zM14 7.5V13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7.5A3.5 3.5 0 0 1 5.5 4h5A3.5 3.5 0 0 1 14 7.5" />
			</svg>
		),
	},
	{
		name: "Add Logo",
		value: 5,
		helpingText: "Add User Logos",
		route: "/addCustomerLogo",
		sprite: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="28"
				height="40"
				fill="#205493"
				className="bi bi-robot"
				viewBox="0 0 16 16"
			>
				<path d="M6 12.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M3 8.062C3 6.76 4.235 5.765 5.53 5.886a26.6 26.6 0 0 0 4.94 0C11.765 5.765 13 6.76 13 8.062v1.157a.93.93 0 0 1-.765.935c-.845.147-2.34.346-4.235.346s-3.39-.2-4.235-.346A.93.93 0 0 1 3 9.219zm4.542-.827a.25.25 0 0 0-.217.068l-.92.9a25 25 0 0 1-1.871-.183.25.25 0 0 0-.068.495c.55.076 1.232.149 2.02.193a.25.25 0 0 0 .189-.071l.754-.736.847 1.71a.25.25 0 0 0 .404.062l.932-.97a25 25 0 0 0 1.922-.188.25.25 0 0 0-.068-.495c-.538.074-1.207.145-1.98.189a.25.25 0 0 0-.166.076l-.754.785-.842-1.7a.25.25 0 0 0-.182-.135" />
				<path d="M8.5 1.866a1 1 0 1 0-1 0V3h-2A4.5 4.5 0 0 0 1 7.5V8a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1v1a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1v-.5A4.5 4.5 0 0 0 10.5 3h-2zM14 7.5V13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7.5A3.5 3.5 0 0 1 5.5 4h5A3.5 3.5 0 0 1 14 7.5" />
			</svg>
		),
	},
];

export const defaultColumns = [
	{
		accessorKey: "date",
		header: () => "Date",
		width: "5%",
		cell: ({ row }: { row: any }) => {
			return new Intl.DateTimeFormat("en-us").format(
				new Date(row.original.date)
			);
		},
	},
	{
		accessorKey: "name",
		header: () => "Added By",
		width: "10%",
	},
	{
		accessorKey: "product_Name",
		header: () => "Product Name",
	},
	{
		accessorKey: "vendor_Name",
		header: () => "Vendor Name",
		width: "10%",
	},
	{
		accessorKey: "service_Type",
		header: () => "Service Type",
		width: "10%",
	},

	{
		accessorKey: "vendor_Category",
		header: () => "Vendor Category",
		width: "10%",
	},

	{
		accessorKey: "delivery_Model",
		header: () => "Delivery Model",
		width: "10%",
	},
	{
		accessorKey: "rating",
		header: () => "Rating",
	},
	{
		accessorKey: "negative_Experience",
		header: () => "Negative Experience",
		width: "10%",
	},
	{
		accessorKey: "positive_Experience",
		header: () => "Positive Experience",
		width: "10%",
	},
	{
		accessorKey: "advice",
		header: () => "Advice",
		width: "10%",
	},
];

export const defaultGovernanceColumns = [
	{
		accessorKey: "date",
		header: () => "Date",
		width: "5%",
		cell: ({ row }: { row: any }) => {
			return new Intl.DateTimeFormat("en-us").format(
				new Date(row.original.date)
			);
		},
	},
	{
		accessorKey: "name",
		header: () => "Added By",
		width: "10%",
	},
	{
		accessorKey: "persona",
		header: () => "Persona",
		width: "10%",
	},
	{
		accessorKey: "question",
		header: () => "Question",
		width: "20%",
	},
	{
		accessorKey: "answer",
		header: () => "Answer",
		width: "20%",
	},
	{
		accessorKey: "maturity_level",
		header: () => "Maturity Level",
		width: "10%",
	},
	{
		accessorKey: "user_id",
		header: () => "User ID",
		width: "10%",
	},
	{
		accessorKey: "id",
		header: () => "ID",
		width: "5%",
	},
];

export const defaultUserSearchColumns = [
	{
		accessorKey: "timestamp",
		header: () => "Date & Time",
		width: "5%",
		cell: ({ row }: { row: any }) => {
			const date = new Date(row?.original?.timestamp);
			return isNaN(date.getTime())
				? "Invalid Date"
				: new Intl.DateTimeFormat("en-us", {
						dateStyle: "medium",
						timeStyle: "short",
				  }).format(date);
		},
	},
	{
		accessorKey: "user_email",
		header: () => "Email",
		width: "20%",
	},
	{
		accessorKey: "query",
		header: () => "Question Posed",
		width: "20%",
	},
	{
		accessorKey: "use_case",
		header: () => "Selected Use Case",
		width: "20%",
		cell: ({ row }: { row: any }) => {
			return getUseCaseName(row?.original?.use_case);
		},
	},
	{
		accessorKey: "error_details",
		header: () => "Error Details",
		width: "20%",
	},
];

export const userLoginActivityColumns = [
	{
		accessorKey: "id",
		header: () => "Record ID",
		width: "5%",
	},
	{
		accessorKey: "user_email",
		header: () => "User Email",
		width: "20%",
	},
	{
		accessorKey: "login_time",
		header: () => "Login Time",
		width: "20%",
		cell: ({ row }: { row: any }) => {
			const loginTime = new Date(row?.original?.login_time);
			return isNaN(loginTime.getTime())
				? "Invalid Date"
				: new Intl.DateTimeFormat("en-us", {
						dateStyle: "medium",
						timeStyle: "short",
				  }).format(loginTime);
		},
	},
	{
		accessorKey: "status",
		header: () => "Status",
		width: "10%",
	},
];

export const userManagementColumns = [
	{
		id: "select",
		cell: ({ row }: any) => (
			<input
				style={{ padding: "15px" }}
				type="checkbox"
				checked={row.getIsSelected()}
				onChange={row.getToggleSelectedHandler()}
			/>
		),
		width: "3%",
	},
	{
		accessorKey: "id",
		header: () => "ID",
		width: "5%",
	},
	{
		accessorKey: "email",
		header: () => "Email",
		width: "15%",
	},
	{
		accessorKey: "full_name",
		header: () => "Full Name",
		width: "15%",
	},
	{
		accessorKey: "account_type",
		header: () => "Account Type",
		width: "10%",
		cell: ({ row }: { row: any }) => {
			const accountTypes = {
				0: "Free",
				1: "Premium",
				2: "Advisor",
				3: "Service Provider",
			};
			return (
				accountTypes[row.original.account_type as keyof typeof accountTypes] ||
				"Unknown"
			);
		},
	},
	{
		accessorKey: "is_admin",
		header: () => "Is Admin?",
		width: "10%",
		cell: ({ row }: { row: any }) => (row.original.is_admin ? "Yes" : "No"),
	},
	{
		accessorKey: "is_enabled",
		header: () => "Is Suspended?",
		width: "10%",
		cell: ({ row }: { row: any }) => (row.original.is_enabled ? "No" : "Yes"),
	},
	{
		accessorKey: "company",
		header: () => "Company",
		width: "10%",
	},
	{
		accessorKey: "title",
		header: () => "Title",
		width: "10%",
	},
	{
		accessorKey: "industry",
		header: () => "Industry",
		width: "10%",
	},
	{
		accessorKey: "company_size",
		header: () => "Company Size",
		width: "10%",
	},
	{
		accessorKey: "budget_accountability",
		header: () => "Budget Accountability",
		width: "10%",
	},
	{
		accessorKey: "last_request_date",
		header: () => "Last Request",
		width: "10%",
		cell: ({ row }: { row: any }) => {
			return row.original.last_request_date
				? new Intl.DateTimeFormat("en-us").format(
						new Date(row.original.last_request_date)
				  )
				: "Never";
		},
	},
];

export const userLoggedInColumns = [
	{
		accessorKey: "id",
		header: () => "Record ID",
		width: "5%",
	},
	{
		accessorKey: "user_email",
		header: () => "User Email",
		width: "20%",
	},
	{
		accessorKey: "login_time",
		header: () => "Login Time",
		width: "20%",
		cell: ({ row }: { row: any }) => {
			const loginTime = new Date(row?.original?.login_time);
			return isNaN(loginTime.getTime())
				? "Invalid Date"
				: new Intl.DateTimeFormat("en-us", {
						dateStyle: "medium",
						timeStyle: "short",
				  }).format(loginTime);
		},
	},
	{
		accessorKey: "logout_time",
		header: () => "Logout Time",
		width: "20%",
		cell: ({ row }: { row: any }) => {
			return row.original.logout_time
				? new Intl.DateTimeFormat("en-us", {
						dateStyle: "medium",
						timeStyle: "short",
				  }).format(new Date(row.original.logout_time))
				: "N/A";
		},
	},
	{
		accessorKey: "status",
		header: () => "Status",
		width: "10%",
	},
];

export const conversationHistoryColumns = [
	{
		accessorKey: "id",
		header: () => "Conversation ID",
		width: "5%",
	},
	{
		accessorKey: "user_id",
		header: () => "User ID",
		width: "5%",
	},
	{
		accessorKey: "user_email",
		header: () => "User Email",
		width: "15%",
	},
	{
		accessorKey: "conversation",
		header: () => "Search Query",
		width: "20%",
		cell: ({ row }: { row: any }) => {
			const conversation = row.original?.conversation || [];
			if (conversation.length >= 2) {
				return conversation[1]?.question || "N/A";
			}
			return conversation.length > 0 ? conversation[0]?.question : "N/A";
		},
	},
	{
		accessorKey: "conversation",
		header: () => "Use Case",
		width: "15%",
		id: "useCase",
		cell: ({ row }: { row: any }) => {
			const label = row.original.conversation && row.original.conversation.length > 0
				? row.original.conversation[0].label
				: "";
			return getUseCaseName(label) || label || "N/A";
		},
	},
	{
		accessorKey: "conversation",
		header: () => "Date & Time",
		width: "15%",
		id: "dateTime",
		cell: ({ row }: { row: any }) => {
			const date = row.original.conversation && row.original.conversation.length > 0
				? new Date(row.original.conversation[0].date)
				: null;
			return date
				? new Intl.DateTimeFormat("en-us", {
						dateStyle: "medium",
						timeStyle: "short",
				  }).format(date)
				: "N/A";
		},
	},
	{
		accessorKey: "conversation",
		header: () => "Messages Count",
		width: "10%",
		id: "messageCount",
		cell: ({ row }: { row: any }) => {
			return row.original.conversation ? row.original.conversation.length * 2 : 0;
		},
	},
];

export const getUseCaseName = (useCaseText: string): string | undefined => {
	const value = parseInt(useCaseText?.split("_")[2], 10);
	const useCase = useCases.find((uc) => uc.value === value);
	return useCase ? useCase.name : undefined;
};
